import React from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import LockPersonTwoToneIcon from '@mui/icons-material/LockPersonTwoTone';
import "./unauthorized.scss"

const Unauthorized = () => {

    const navigate = useNavigate();

    return (
        <div className="unauthorized">
            <Helmet>
                <title>403 - Keine Berechtigung</title>
            </Helmet>
            <div className="container">
                <div className="left">
                    <div className="box">
                        <h5>ERROR 403</h5>
                    </div>
                    <h2>Es tut uns leid!</h2>
                    <p>Leider hast du keine Berechtigung die Seite aufzurufen.</p>
                    <button onClick={() => navigate(-1)} style={{marginTop: "20px"}}>Zurück</button>
                </div>
                <div className="symbol">
                    <div className="circle">
                        <LockPersonTwoToneIcon />
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Unauthorized